import { Box, Card, Grid, Toolbar, Typography } from '@material-ui/core'
import axios from 'axios'
import arrayMutators from 'final-form-arrays'
import * as HttpStatus from 'http-status-codes'
import get from 'lodash/get'
import { useState } from 'react'
import { BooleanInput, Labeled, Loading, useGetOne, useNotify, useRedirect } from 'react-admin'
import { Form } from 'react-final-form'

import { captureExceptionIfProduction, getLoadStop } from 'helpers/utils'
import {
  BookingTypes,
  DESTINATION,
  LABEL_DROPOFF_DATE,
  LABEL_ORIGIN_TO_DESTINATION,
  LABEL_PICKUP_DATE,
  ORIGIN,
} from '../../helpers/constants'
import { BookApproveLoadButton, BookingType, bookingTypeLabelText } from '../Common/FeasibilityCheck'
import {
  AssignedDriverReferenceInput,
  LabeledTypographyField,
  LocalizedStopDateTimeField,
  OriginDestinationField,
} from '../Fields'

const BookLoadForm = ({ match, ...props }: any) => {
  const redirectTo = useRedirect()
  const notify = useNotify()
  const contactedLoadTeamId = get(props, 'location.state.contactedLoadTeamId')
  const resource = contactedLoadTeamId ? 'contacted-loads' : 'loads'
  const [bookingload, setBookingLoad] = useState(false)
  const { data, loading, error } = useGetOne(resource, match.params.id)
  if (loading || bookingload) {
    return <Loading />
  }
  if (error) {
    return <p>Error</p>
  }

  const load = contactedLoadTeamId ? data?.load : data

  const bookingType = contactedLoadTeamId
    ? BookingTypes.OfflineBook
    : load.instant_book
    ? BookingTypes.InstantBook
    : BookingTypes.StandardBook

  const submit = (values: any) => {
    setBookingLoad(true)
    let payload: any = {
      assigned_to: values.assigned_to,
      booking_type: bookingType,
    }
    if (values.book !== null) {
      payload.book = values.book
    }
    axios
      .post(`/api/v1/console/${resource}/${data?.id}/book/`, payload)
      .then((response) => {
        if (response.status === HttpStatus.CREATED) {
          setBookingLoad(false)
          notify('Load successfully booked!', { type: 'success' })
          redirectTo(`/jobs/${response.data.id}/show`)
        }
      })
      .catch((error) => {
        console.error('Load failed to be booked: ', error)
        setBookingLoad(false)
        notify(`${error.response.statusText}: ${JSON.stringify(error.response.data)}`, { type: 'warning' })
        captureExceptionIfProduction(error)
      })
  }

  var initialValues: any = {
    load: load,
  }

  if (load.instant_book) {
    initialValues.book = true
  }

  const originStop = getLoadStop(load, ORIGIN)
  const destStop = getLoadStop(load, DESTINATION)
  const bookingTypeLabel = load.instant_book ? bookingTypeLabelText.instant : bookingTypeLabelText.standard
  const booking_type = load.instant_book ? BookingType.instant : BookingType.standard
  const tripRate = load.trip_rate || 'N/A'
  return (
    <>
      <Card style={{ padding: 20 }}>
        <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={2}>
          <Grid item xs={12}>
            <Typography component="span" variant="h5" color="textPrimary">
              Book load for a driver
            </Typography>
          </Grid>
          <Grid container item direction="row">
            <Grid item xs={2}>
              <LabeledTypographyField label="Source" variant="body1" value={load.source} />
            </Grid>
            <Grid item xs={2}>
              <LabeledTypographyField label="Source ID" variant="body1" value={load.source_human_id} />
            </Grid>
            <Grid item xs={2}>
              <LabeledTypographyField label="Booking type" variant="body1" value={bookingTypeLabel} />
            </Grid>
            <Grid item xs={2}>
              <LabeledTypographyField label="Rate" variant="body1" value={tripRate} />
            </Grid>
            <Grid item xs={2}>
              <LabeledTypographyField label="ID" variant="body1" value={load.id} />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Labeled label={LABEL_ORIGIN_TO_DESTINATION}>
              <OriginDestinationField record={load} />
            </Labeled>
          </Grid>
          <Grid item xs={12}>
            <Labeled label={LABEL_PICKUP_DATE}>
              <LocalizedStopDateTimeField record={originStop} source="date_start" />
            </Labeled>
          </Grid>
          <Grid item xs={12}>
            <Labeled label={LABEL_DROPOFF_DATE}>
              <LocalizedStopDateTimeField record={destStop} source="date_start" />
            </Labeled>
          </Grid>
          <Grid item>
            <Box p="1em">
              <Box display="flex">
                <Form
                  initialValues={initialValues}
                  onSubmit={submit}
                  mutators={{ ...arrayMutators }}
                  subscription={defaultSubscription}
                  keepDirtyOnReinitialize
                  render={(formProps) => {
                    return (
                      <form>
                        <Box p="1em">
                          <Box display="flex" alignItems="center">
                            <Box flex={1} mr="1em" width={500}>
                              <AssignedDriverReferenceInput contactedLoadTeamId={contactedLoadTeamId} />
                            </Box>
                            <Box flex={1}>
                              {formProps.values.load.instant_book && (
                                <BooleanInput source="book" label="Execute instant book" />
                              )}
                            </Box>
                          </Box>
                          <Toolbar>
                            <Box display="flex" justifyContent="space-between" width="100%">
                              {formProps.values.assigned_to && (
                                <BookApproveLoadButton
                                  id={formProps.values.load.id}
                                  load={formProps.values.load}
                                  assignedTo={formProps.values.assigned_to}
                                  bookingType={booking_type}
                                  onSubmit={formProps.handleSubmit}
                                />
                              )}
                            </Box>
                          </Toolbar>
                        </Box>
                      </form>
                    )
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </>
  )
}

const defaultSubscription = {
  submitting: true,
  pristine: true,
  valid: true,
  invalid: true,
  values: true,
}

export default BookLoadForm
